import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import QuickPinGate from './QuickPinGate';

export default function ProtectedRoute({ children, admin = false }) {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) return <div className="loading-screen"><div className="loader" /><p>Loading secure portal…</p></div>;
  if (!user) return <Navigate to="/portal/login" replace state={{ from: location.pathname }} />;
  if (admin && !isAdmin) return <Navigate to="/portal" replace />;
  return <QuickPinGate>{children}</QuickPinGate>;
}
